export default __webpack_public_path__ + "static/media/img1.184d0b30.jpg";